import {HomeView} from "./home";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {Occupancy} from "@variocube/app-api";
import {CustomerStore} from "./customer-store/customer-store";
import {CustomerPickup} from "./customer-pickup/customer-pickup";
import {CarrierStore} from "./carrier-store/carrier-store";
import {CarrierRetrieval, CarrierSingleRetrieval} from "./carrier-retrieval";
import {BackendApiCredentials, Carriers, OutboundDelivery} from "./types";
import {useActivateListener, useStorageItemValue} from "@variocube/cube-ui";
import { useAuthenticatedCarrier, useCarriers } from "./CarrierProvider";
import { CarrierAuthenticated } from './carrier-authenticated';

export interface AppProps {
    onCarriers: (carriers: Carriers) => void;
}

export function App({onCarriers}: AppProps) {
    const carriers = useCarriers();
    const tenantLogoUrl = useStorageItemValue<string>("tenantLogoUrl");

    const backendApiCredentials = useStorageItemValue<BackendApiCredentials>("backendApiCredentials");

    const [carrierStore, setCarrierStore] = useState<Occupancy>();
    const [customerStore, setCustomerStore] = useState<OutboundDelivery>();
    const [customerPickup, setCustomerPickup] = useState<Occupancy[]>();
    const [carrierRetrieval, setCarrierRetrieval] = useState<Occupancy[]>();
    const authenticatedCarrier = useAuthenticatedCarrier();

    useEffect(() => {
        if (carriers) {
            onCarriers(carriers);
        }
    }, [carriers, onCarriers]);

    const handleCustomerPickupDone = useCallback(() => setCustomerPickup(undefined), []);
    const handleCarrierStoreDone = useCallback(() => setCarrierStore(undefined), []);
    const handleCustomerStoreDone = useCallback(() => setCustomerStore(undefined), []);
    const handleCarrierRetrievalDone = useCallback(() => setCarrierRetrieval(undefined), []);

    const handleActivate = useCallback(() => {
        setCustomerPickup(undefined);
        setCarrierStore(undefined);
        setCustomerStore(undefined);
        setCarrierRetrieval(undefined);
    }, []);
    useActivateListener(handleActivate);

    if (customerStore) {
        return <CustomerStore delivery={customerStore} onDone={handleCustomerStoreDone} backendApiCredentials={backendApiCredentials}/>;
    }
    if (carrierStore) {
        return <CarrierStore reservation={carrierStore} onDone={handleCarrierStoreDone}/>;
    }
    if (customerPickup?.length) {
        return <CustomerPickup occupancies={customerPickup} onDone={handleCustomerPickupDone} backendApiCredentials={backendApiCredentials}/>;
    }
    if (authenticatedCarrier) {
        return <CarrierAuthenticated backendApiCredentials={backendApiCredentials} />;
    }
    if (carrierRetrieval) {
        if (carrierRetrieval.length == 1) {
            return <CarrierSingleRetrieval occupancy={carrierRetrieval[0]} onDone={handleCarrierRetrievalDone}/>;
        }
        else {
            return <CarrierRetrieval occupancies={carrierRetrieval} onDone={handleCarrierRetrievalDone}/>;
        }
    }
    return (
        <HomeView
            carriers={carriers}
            tenantLogoUrl={tenantLogoUrl}
            onCustomerPickup={setCustomerPickup}
            onCarrierRetrieval={setCarrierRetrieval}
            onCarrierStore={setCarrierStore}
            onCustomerStore={setCustomerStore}
            backendApiCredentials={backendApiCredentials}
        />
    );
}
